<template>
    <div class="wrapT">
        <!--标题-->
        <div class="headerT">
            <!-- 分类: -->
            <span class="headerSpanT">分类：</span>
            <span
                :class="[{ chooseColor: isColor == index }, headerSpanT]"
                v-for="(val, index) in arrOne"
                :key="index"
                @click="changeColor(index), changeData(val.id)"
                >{{ val.navigationName }}</span
            >
        </div>
        <!--内容-->
        <div class="zixun-box flex-row">
            <div
                v-for="(item, index) in arrTwo"
                :key="index"
                class="zixun-item"
            >
                <div
                    @click="goDetails(item.id)"
                    class="zixun-item-img bg scale-box"
                >
                    <img :src="item.image" :alt="item.title" />
                </div>
                <div class="zixun-item-content">
                    <h2>{{ item.title }}</h2>
                    <p class="tips">
                        <span>{{
                            item.creaTime && item.creaTime.time | dateFormat
                        }}</span>
                        <span>浏览次数：{{ item.popularity }}</span>
                    </p>
                    <p class="intro">
                        {{
                            item.introduction && item.introduction.length > 80
                                ? item.introduction.substring(0, 80) + "..."
                                : item.introduction
                        }}
                        <span class="view-more" @click="goDetails(item.id)"
                            >&lt;查看更多&gt;</span
                        >
                    </p>
                </div>
            </div>
        </div>
        <pagebreak :totalPage="totalPage" @changePage="changePage"></pagebreak>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "gjtz",
    data() {
        return {
            arrOne: [], //分类列表
            arrTwo: [],
            totalPage: 1,
            headerSpanT: "headerSpanT",
            isColor: 0,
            isClassify: 10000,
            cancelFn: null
        };
    },
    methods: {
        changeColor(index) {
            this.isColor = index;
        },
        changePage(page) {
            this.getData(page);
        },
        changeData(id) {
            this.isClassify = id;
            this.getData(1);
        },
        //资讯详情
        goDetails(i) {
            console.log(this.arrOne)
            this.$router.push({
                name: "artDetail",
                query: {
                    id: i,
                    t1: this.arrOne[this.isColor].navigationName
                }
            });
        },
        getData(page) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    navigationId: this.isClassify,
                    current: page
                },
                success: res => {
                    if (res.code == 200) {
                        this.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                        this.arrTwo = res.message.records;
                    }
                },
                error: res => {}
            });
        }
    },
    created() {
        this.getData(1);
        //获取分类列表
        this.$ajax({
            method: "post",
            url: "homePage/myNavigation",
            success: res => {
                for (var i = 0; i < res.message.length; i++) {
                    if (res.message[i].id == 10000) {
                        this.arrOne = res.message[i].subList;
                        this.arrOne.unshift({
                            id: 10000,
                            navigationName: "全部"
                        });
                    }
                }
            },
            error: res => {
                console.log(res);
            }
        });
    }
};
</script>
<style scoped="scoped" lang="scss">
.wrapT {
    width: 1000px;
    overflow: hidden;
    margin: 20px auto;
    min-height: 500px;
}

.headerT {
    margin: 10px 0;
}

.headerSpanT {
    margin-right: 30px;
    color: black;
    cursor: pointer;
}

.chooseColor {
    color: #6ac0e8;
}

.zixun-box {
    margin-top: 20px;
    min-height: 500px;
    align-items: flex-start;
    align-content: flex-start;
    .zixun-item {
        margin-right: 35px;
        margin-bottom: 20px;
        font-size: 14px;
        .zixun-item-img {
            display: inline-block;
            vertical-align: top;
            height: 164px;
            width: 242px;
            border: 1px solid #ddd;
            box-sizing: border-box;
            img {
                width: 100%;
                min-height: 100%;
            }
        }
        .zixun-item-content {
            display: inline-block;
            vertical-align: top;
            margin-left: 6px;
            width: 230px;
            height: 164px;
            h2 {
                padding: 5px 0;
                font-size: 16px;
                line-height: 20px;
                font-weight: bold;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .tips {
                line-height: 20px;
                color: #666;
                span:nth-child(1) {
                    margin-right: 20px;
                }
            }
            .intro {
                margin-top: 5px;
                line-height: 18px;
                height: 90px;
                overflow: hidden;
                position: relative;
                word-break: break-all;
            }
            .view-more {
                display: inline-block;
                height: 18px;
                line-height: 18px;
                color: #3366cc;
                background-color: #fff;
                cursor: pointer;
            }
        }
    }
    .zixun-item:nth-child(2n) {
        margin-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/gjtz/gjtz.vue